import { useAppSettingsService } from "src/services/appSettingsService/appSettingsService";

import { useCurrentWorkspace } from "@dashboard/workspaces/api/helpers";

import { getRecommendedPathForUser } from "./dashboardRouting";

export function useRecommendedPathForUser(): { path: string; isLoading: boolean } {
    const {
        effectiveWorkspaceSettings,
        rawTenantSettings,
        isLoading: workspaceLoading,
        isFetching: workspaceFetching,
    } = useAppSettingsService();
    const { data: workspace } = useCurrentWorkspace();

    const isWorkspaceLoading = workspaceLoading || (workspaceFetching && workspace === null);

    const path = getRecommendedPathForUser({
        effective: effectiveWorkspaceSettings,
        pages: rawTenantSettings.features.pages,
    });

    return {
        path,
        isLoading: isWorkspaceLoading,
    };
}
